class KaryawanEntity {
  id: number;
  ncode: string;
  id_card: string;
  nama: string;
  departemen: string;

  constructor(object: {
    id: number;
    ncode: string;
    id_card: string;
    nama: string;
    departemen: string;
  }) {
    this.id = object.id;
    this.ncode = object.ncode;
    this.id_card = object.id_card;
    this.nama = object.nama;
    this.departemen = object.departemen;
  }
}

class EditKaryawanEntity {
  id: number;
  ncode: string;
  id_card: string;
  nama: string;
  id_departemen?: number;
  departemen: string;

  constructor(object: {
    id: number;
    ncode: string;
    id_card: string;
    nama: string;
    id_departemen?: number;
    departemen: string;
  }) {
    this.id = object.id;
    this.ncode = object.ncode;
    this.id_card = object.id_card;
    this.nama = object.nama;
    this.departemen = object.departemen;
    this.id_departemen = object.id_departemen;
  }
}

class AddKaryawanEntity {
  ncode?: string;
  id_card?: string;
  nama?: string;
  id_departemen?: number;
  departemen?: string;

  constructor(object: {
    ncode?: string;
    id_card?: string;
    nama?: string;
    id_departemen?: number;
    departemen?: string;
  }) {
    this.ncode = object.ncode;
    this.id_card = object.id_card;
    this.nama = object.nama;
    this.departemen = object.departemen;
    this.id_departemen = object.id_departemen;
  }
}

class ImportKaryawanEntity {
  ncode: string;
  id_card: string;
  nama: number;
  departemen: string;

  constructor(object: {
    ncode: string;
    id_card: string;
    nama: number;
    departemen: string;
  }) {
    this.ncode = object.ncode;
    this.id_card = object.id_card;
    this.nama = object.nama;
    this.departemen = object.departemen;
  }
}

export { KaryawanEntity, EditKaryawanEntity, AddKaryawanEntity, ImportKaryawanEntity };